import SectorHero from "@/components/SectorHero";
import TopicGrid from "@/components/TopicGrid";
import MethodTimeline from "@/components/MethodTimeline";
import StatsBand from "@/components/StatsBand";
import ContactSection from "@/components/ContactSection";
import { residentialTopics } from "@/data/sectors";

export default function Residentiel() {
  return (
    <div data-testid="residentiel-page">
      <SectorHero
        kicker="03 · Résidentiel"
        title="Plus chaud, moins cher, mieux isolé."
        blurb="Particuliers, copropriétés, bailleurs sociaux : nous mobilisons les primes CEE, MaPrimeRénov' et les Coups de Pouce pour financer vos travaux d'isolation, de chauffage, de ventilation et de rénovation globale."
        image="https://images.pexels.com/photos/9173035/pexels-photo-9173035.jpeg"
        tags={["MaPrimeRénov'", "Coup de Pouce", "Pompe à chaleur", "Copropriétés", "Bailleurs sociaux"]}
      />
      <TopicGrid
        kicker="Rénovations éligibles"
        title="Chaque euro de confort, optimisé par les CEE."
        topics={residentialTopics}
      />
      <MethodTimeline />
      <StatsBand dark={false} />
      <ContactSection />
    </div>
  );
}
